import React, { useEffect, useRef, useState } from 'react';
import { emojiIndex } from 'emoji-mart';
import emojiData from 'emoji-mart/data/all.json';
import { resolveEmoji } from 'functions/chatEmoji';
import LadderEmoji from 'react/elements/LadderEmoji';
import { __ } from 'i18n/index';

const frequent = ['fire', 'joy', '+1', 'eyes', 'heart', 'tada', 'sob', 'raised_hands'];

// One-tap reactions in the message menu: the first six of the frequent list.
export const QUICK_REACTIONS = frequent.slice(0, 6);
const icons = ['☺', '♧', '♨', '⚽', '✈', '♜', '♡', '⚑'];

export default function EmojiPicker({ onSelect, onClose, reaction = false, triggerRef }) {
	const [query, setQuery] = useState('');
	const [category, setCategory] = useState('frequent');
	const [skin, setSkin] = useState(1);
	const [hovered, setHovered] = useState('fire');
	const pickerRef = useRef(null);
	useEffect(() => {
		const outside = event => {
			if (!pickerRef.current?.contains(event.target) && !triggerRef?.current?.contains(event.target)) onClose();
		};
		const escape = event => {
			if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); onClose(); }
		};
		document.addEventListener('pointerdown', outside);
		document.addEventListener('keydown', escape, true);
		return () => {
			document.removeEventListener('pointerdown', outside);
			document.removeEventListener('keydown', escape, true);
		};
	}, [onClose, triggerRef]);
	const selectedCategory = emojiData.categories.find(entry => entry.id === category);
	const entries = query.trim() ? (emojiIndex.search(query.trim()) || []).map(entry => entry.id) : selectedCategory?.emojis || frequent;
	const chooseCategory = id => { setCategory(id); setQuery(''); };
	return <section ref={pickerRef} className='chat_emoji_popover' aria-label={reaction ? __('Add a reaction') : __('Emoji picker')}>
		<header><div><small>{__('EXPRESS YOURSELF')}</small><h2>{reaction ? __('Add a reaction') : __('Emoji')}</h2></div>
			<button type='button' aria-label={__('Close emoji picker')} onClick={onClose}>×</button></header>
		<label className='chat_emoji_search'><i className='fa fa-search' aria-hidden='true' />
			<input type='search' autoFocus value={query} onChange={event => setQuery(event.target.value)} placeholder={__('Search emoji')} aria-label={__('Search emoji')} />
		</label>
		<nav aria-label={__('Emoji categories')}>
			<button type='button' aria-label={__('Frequently used')} title={__('Frequently used')} aria-pressed={category === 'frequent'} onClick={() => chooseCategory('frequent')}>◷</button>
			{emojiData.categories.map((entry, index) => <button type='button' key={entry.id} aria-label={entry.name} title={entry.name} aria-pressed={category === entry.id} onClick={() => chooseCategory(entry.id)}>{icons[index]}</button>)}
		</nav>
		<div className='chat_emoji_grid_heading'><b>{query.trim() ? __('Search results') : selectedCategory?.name || __('Frequently used')}</b>
			<label>{__('Skin tone')}<select aria-label={__('Skin tone')} value={skin} onChange={event => setSkin(Number(event.target.value))}>
				{[1, 2, 3, 4, 5, 6].map(tone => <option key={tone} value={tone}>{tone === 1 ? __('Default') : ['🏻', '🏼', '🏽', '🏾', '🏿'][tone - 2]}</option>)}
			</select></label>
		</div>
		<div className='chat_emoji_grid'>
			{!entries.length && <p role='status'>{__('No emoji found. Try another search.')}</p>}
			{entries.map(id => {
				const emoji = resolveEmoji(id, skin);
				return emoji && <button type='button' key={id} aria-label={`${__('Select')} :${id}:`} title={`:${id}:`} onMouseEnter={() => setHovered(id)} onFocus={() => setHovered(id)} onClick={() => onSelect(emoji)}>
					<LadderEmoji emoji={emoji} size={26} tooltip={false} />
				</button>;
			})}
		</div>
		<footer><span><LadderEmoji emoji={hovered} skin={skin} /> <b>:{hovered}:</b></span><small>{__('Esc to close')}</small></footer>
	</section>;
}
